let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kEWnj")).then(() => parcelRequire('j8q0P'));